import { makeStyles, Spinner } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    display: "grid",
    width: "100dvw",
    height: "100dvh",
    placeItems: "center",
  },
});

function LoadingIndicator() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Spinner labelPosition="after" label="Loading app..." />
    </div>
  );
}

export default LoadingIndicator;
